import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
    item: {
      width: 'calc(100% / 3)',
      minWidth: 86,
      marginBottom: theme.spacing(2),
    },
  })
);
